import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useNCallContext } from "../../context/ncall-context";
import moment from "moment";

function ScheduleDetailModal({ schedule }) {
  const { openDetailModal, setOpenDetailModal } = useNCallContext();

  const cancelButtonRef = useRef(null);

  const { date, employeeId, employeeName, shortNote, scheduleStatus, shifts } =
    schedule;

  return (
    <Transition.Root show={openDetailModal} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpenDetailModal}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div className="mt-2 text-center sm:mt-3 ">
                    <Dialog.Title
                      as="h3"
                      className="text-base font-semibold leading-6 py-2 text-gray-900"
                    >
                      Schedule Detail
                    </Dialog.Title>
                    <div className="pt-4 border-t-2">
                      <div className="flex flex-col  items-start justify-start">
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Schedule Status
                          </h4>
                          <span className="text-sm font-medium">
                            {scheduleStatus === "passed" ? (
                              <span className="text-sm font-bold uppercase text-rose-500">
                                Passed
                              </span>
                            ) : (
                              <span className="text-sm font-bold uppercase text-green-500">
                                In-Progress
                              </span>
                            )}
                          </span>
                        </div>
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Employee Id
                          </h4>
                          <span className="text-sm font-medium">
                            {employeeId}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col  items-start justify-start">
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Employee Name
                          </h4>
                          <span className="text-sm font-medium">
                            {employeeName}
                          </span>
                        </div>
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Employee Id
                          </h4>
                          <span className="text-sm font-medium">
                            {employeeId}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col items-start justify-start">
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Department
                          </h4>
                          <span className="text-sm font-medium">
                            {schedule.Department.department}
                          </span>
                        </div>
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Status Id
                          </h4>
                          <span className="text-sm font-medium">
                            {schedule.Department.statusId}
                          </span>
                        </div>
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Color
                          </h4>
                          <div
                            style={{
                              backgroundColor: schedule.Department.color,
                            }}
                            className="h-3 w-3"
                          ></div>
                          <span className="text-sm font-medium">
                            {schedule.Department.color}
                          </span>
                        </div>
                      </div>

                      <div className="flex flex-col items-start justify-start">
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Date
                          </h4>
                          <span className="text-sm font-medium">
                            {moment(date).format("MMMM Do YYYY")}
                          </span>
                        </div>
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Start Time
                          </h4>
                          <span className="text-sm font-medium">
                            {moment(shifts.startTime, "hh:mm A").format(
                              "hh:mm A"
                            )}
                          </span>
                        </div>
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            End Time
                          </h4>
                          <span className="text-sm font-medium">
                            {moment(shifts.endTime, "hh:mm A").format(
                              "hh:mm A"
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col items-start justify-start">
                        <div className="w-full flex flex-row gap-2 items-center justify-start">
                          <h4 className="text-left  w-1/3 py-1 block text-sm font-semibold text-gray-700">
                            Job Tiltle
                          </h4>
                          <span className="text-sm font-medium">
                            {shortNote}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 flex flex-row justify-end gap-2 items-end">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                    onClick={() => setOpenDetailModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default ScheduleDetailModal;
